import { useEffect, useState } from 'react'
import classes from './style.module.scss'
import PropTypes from 'prop-types'
import closeIcon from '../../../assets/icons/close.png'
import { CheckboxInput } from '@Root/components'

export const ConfirmationModal = ({
  text,
  checkboxLabel,
  requireCheckbox,
  clickRejectButtonHandler,
  clickResolveButtonHandler,
}) => {
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false)
  const canProceed = !requireCheckbox || isCheckboxChecked

  useEffect(() => {
    setIsCheckboxChecked(false)
  }, [text, checkboxLabel])

  const handleProceed = () => {
    if (!canProceed) {
      return
    }

    clickResolveButtonHandler(checkboxLabel ? isCheckboxChecked : false)
  }

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <div className={classes.icon} onClick={clickRejectButtonHandler}>
          <img src={closeIcon} alt='' />
        </div>
      </div>
      <div className={classes.line} />
      <div className={classes.contentText}>{text}</div>
      {checkboxLabel && (
        <div className={classes.checkboxRow}>
          <CheckboxInput
            isChecked={isCheckboxChecked}
            changeHandler={setIsCheckboxChecked}
            label={{ text: checkboxLabel }}
          />
        </div>
      )}
      <div className={classes.line} />
      <div className={classes.buttons}>
        <button className={classes.buttonLeft} onClick={clickRejectButtonHandler}>
          Cancel
        </button>
        <button className={`${classes.buttonRight} ${canProceed ? '' : classes.buttonRightDisabled}`} onClick={handleProceed}>
          Proceed
        </button>
      </div>
    </div>
  )
}

ConfirmationModal.propTypes = {
  text: PropTypes.string,
  checkboxLabel: PropTypes.string,
  requireCheckbox: PropTypes.bool,
  clickRejectButtonHandler: PropTypes.func,
  clickResolveButtonHandler: PropTypes.func,
}

ConfirmationModal.defaultProps = {
  text: null,
  checkboxLabel: null,
  requireCheckbox: false,
  clickRejectButtonHandler: () => {},
  clickResolveButtonHandler: () => {},
}
